import React from "react";
import { connect } from "react-redux";
import { history } from "../../helpers";
import { ExpandingTableWithGroups } from "./ExpandingTableWithGroups";


function SearchResults(props) {
  const { dealjackets, searchRequest, params, org_id } = props;
  const search_results = dealjackets?.searchResults;
  const search_term = dealjackets?.searchTerm;

  const queryTerm = params.t;
  const queryOffset = params.o?Number(params.o):0;

  const generatePaginationText = () => {
    const limit = search_results.limit;
    const offset = search_results.offset;
    const result_count = search_results.result_count;

    if(limit === 0 || result_count < limit) {
      return '1 to '+result_count+' of '+result_count+' results';
    } else {
      var start = offset+1;

      var end = offset+limit>result_count?result_count:offset+limit;

      return ''+start+' to '+end+' of '+result_count+' results';
    }

  }

  const getPrevResults = () => {
    const newOffset=queryOffset-50
    if (newOffset >= 0) {
      //const queryString = "q=All&t=" + queryTerm + "&l=50" + "&o="+newOffset;
      const queryString = `q=All&t=${queryTerm}&l=50&o=${newOffset}`;
      history.push("/org/" + org_id + "/dealjackets?" + queryString);
    }
  }


  const getNextResults = () => {
    const newOffset=queryOffset+50
    if (newOffset < search_results.result_count) {
      const queryString = `q=All&t=${queryTerm}&l=50&o=${newOffset}`;
      
      history.push("/org/" + org_id + "/dealjackets?" + queryString);
    }
  }

  if (search_results.result_count === 0) {
    return (
      <div className="searchTip">
      No results found.
    </div>
    )

  }

  return (

    search_results && (
      <>
        <div className="searchTip">
          { (search_term) &&
            <div className="arrowContainer">
            Search Term: {search_term}
            </div>
          }
          <div className="arrowContainer">
              <div className="backArrow" onClick={() => getPrevResults()}/>
                {generatePaginationText()}
              <div className="nextArrow" onClick={() => getNextResults()}/>
          </div>
        </div>
        <ExpandingTableWithGroups data={search_results} term={search_term} searchRequest={searchRequest} />
        <div className="searchTip">
          <div className="arrowContainer">
              <div className="backArrow" onClick={() => getPrevResults()}/>
                {generatePaginationText()}
              <div className="nextArrow" onClick={() => getNextResults()}/>
          </div>
        </div>
      </>
    )
  );
}

function mapStateToProps(state) {
  const { dealjackets } = state;
  return {
    dealjackets,
  };
}

const connectedSearchResults = connect(mapStateToProps)(SearchResults);
export { connectedSearchResults as SearchResults };
